module.exports = __webpack_public_path__ + "b8723058b93e0634d44bd2990dcc3021.svg";